import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Breadcrumb, BackdropCircular} from 'components';
import {
  Card,
  Typography,
  Divider,
  Grid,
  Switch,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Icon
} from '@material-ui/core';
import {
  getHomepageBenefitsBlockConfigsApi,
  saveHomepageBenefitsBlockConfigsApi
} from 'api';
import {
  changeHomepageBenefitsBlockConfig
} from 'redux/actions/store_configs';


const additionalGroups = [
  {
    pathName: 'is_free_shipping_enabled',
    name: 'Free Shipping Item'
  },
  {
    pathName: 'is_rewards_enabled',
    name: 'Rewards Item'
  },
  {
    pathName: 'is_customer_service_enabled',
    name: 'Customer Service Item'
  }
];


const BenefitsBlock = () => {
  const dispatch = useDispatch();
  const {
    homepageBenefitsBlockConfigs = [],
    loadingHomepageBenefitsBlockConfigs,
    savingHomepageBenefitsBlockConfigs
  } = useSelector((state) => state.store_configs);
  const loading = loadingHomepageBenefitsBlockConfigs || savingHomepageBenefitsBlockConfigs;


  useEffect(() => {
    if (homepageBenefitsBlockConfigs.length === 0) {
      getHomepageBenefitsBlockConfigsApi({dispatch});
    }
  }, []);

  const configValue = (path) => {
    return !homepageBenefitsBlockConfigs.length
      ? ''
      : homepageBenefitsBlockConfigs.find((config) => config.path === `store_info/benefits/${path}`).value;
  };

  const isBlockEnabled = configValue('is_enable');

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeHomepageBenefitsBlockConfig(name, checked, type, value));
  };

  const handleSave = () => {
    saveHomepageBenefitsBlockConfigsApi({dispatch, configs: homepageBenefitsBlockConfigs});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <Breadcrumb
        routeSegments={[
          { name: 'Settings', path: '/settings#go_live_requirements' },
          { name: 'UI Configurations', path: '/settings#UI_configurations' },
          { name: 'Homepage Settings', path: '/configurations/homepage'},
          { name: 'Benefits Block'}
        ]}
      />
      <div className="m-10">
        <Card className="p-8">
          <Typography variant="h4" className="mb-8">Benefits Block</Typography>
          <Divider className="mb-8" />
          <Grid container spacing={3} className="mb-8">
            <Grid item xs={12} sm={2} className="my-2 ml-4">Enable</Grid>
            <Grid item xs={12} sm={9}>
              <Switch
                color="primary"
                name={'store_info/benefits/is_enable'}
                checked={isBlockEnabled == 1}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          {additionalGroups.map((item) => {
            const configValueForItem = configValue(item.pathName);
            return (
              <div key={item.pathName}>
                <Accordion elevation={0}>
                  <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
                    <Typography variant="h3" className="mb-4 capitalize">
                      {item.name}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="flex-column">
                    <Grid container spacing={3} className="mb-8">
                      <Grid item xs={12} sm={2} className="my-2 ml-4">Enable</Grid>
                      <Grid item xs={12} sm={9}>
                        <Switch
                          color="primary"
                          name={`store_info/benefits/${item.pathName}`}
                          checked={configValueForItem == 1}
                          onChange={handleChange}
                        />
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </div>
            );
          })}
        </Card>


        <div className="flex justify-end">
          <Button
            variant="contained"
            color="primary"
            className="my-10"
            onClick={handleSave}
          >
            Save Configurations
          </Button>
        </div>
      </div>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default BenefitsBlock;
